
import { openDB } from "idb";

export default class SaveDraft {
    static savedraftIn_idb(data, PreOpso) {
    
        const saveData = async (data) => {
          if (!("indexedDB" in window)) {
            console.warn("IndexedDB not supported");
            return;
          }
    
          const dbName = "gt_form";
          const storeName = "product_store";
          const version = 1; //versions start at 1
    
          const db = await openDB(dbName, version, {
            upgrade(db, oldVersion, newVersion, transaction) {
              db.createObjectStore(storeName);
            },
          });
    
          const tx = await db.transaction(storeName, "readwrite");
          const store = await tx.objectStore(storeName);
    
    
          if (!data.product_detail) {
            let txss = db.transaction(["product_store"], "readwrite");
            let objectStore = txss.objectStore(storeName);
            // let objectStoreRequest = objectStore.delete("product_detail");
            let objectStoreRequests = objectStore.delete("product_detail");       // eslint-disable-line
    
          } else {
            const product = await store.put(       // eslint-disable-line
              { key: "prod_123", value: data.product_detail },
              "product_detail"
            );
            let draft = await store.put(       // eslint-disable-line
              { key: "draft_123", value: false },
              "is_draft_saved"
            );
          }
    
          if (!data.geographic_detail) {
            let txss = db.transaction(["product_store"], "readwrite");
            let objectStore = txss.objectStore(storeName);
            let objectStoreRequest = objectStore.delete("geo_detail");       // eslint-disable-line
          } else {
            let txss = db.transaction(["product_store"], "readwrite");
            let objectStore = txss.objectStore(storeName);       // eslint-disable-line
            const geo =       // eslint-disable-line
              data.geographic_detail &&
              (await store.put(
                { key: "geo_123", value: data.geographic_detail },
                "geo_detail"
              ));
            let draft = await store.put(       // eslint-disable-line
              { key: "draft_123", value: false },
              "is_draft_saved"
            );
          }
          if (!data.channel_detail) {
            let txss = db.transaction(["product_store"], "readwrite");
            let objectStore = txss.objectStore(storeName);
            let objectStoreRequest = objectStore.delete("channel_detail");       // eslint-disable-line
          } else {
    
            const channel =       // eslint-disable-line
              data.channel_detail &&
              (await store.put(
                {
                  key: "channel_123", value: Object.keys(data.channel_detail).length === 0 && data.channel_detail.constructor === Object
                    ? [] : data.channel_detail
                },
                "channel_detail"
              ));
            let draft = await store.put(       // eslint-disable-line
              { key: "draft_123", value: false },
              "is_draft_saved"
            );
          }
          if (!data.duration_detail) {
            let txss = db.transaction(["product_store"], "readwrite");
            let objectStore = txss.objectStore(storeName);
            let objectStoreRequest = objectStore.delete("duration_detail");       // eslint-disable-line
          } else {
            // const duration = data.duration_detail  && await store.put({"key":"channel_123","value":data.channel_detail },"channel_detail");
            const duration =       // eslint-disable-line
              data.duration_detail &&
              (await store.put(
                { key: "duration_123", value: data.duration_detail },
                "duration_detail"
              ));
            let draft = await store.put(       // eslint-disable-line
              { key: "draft_123", value: false },
              "is_draft_saved"
            );
          }
          if (!data.outlet_attributes) {
            let txss = db.transaction(["product_store"], "readwrite");
            let objectStore = txss.objectStore(storeName);
            let objectStoreRequest = objectStore.delete("outlet_detail");       // eslint-disable-line
          } else {
            const outlet =       // eslint-disable-line
              data.outlet_attributes &&
              (await store.put(
                {
                  key: "outlet_123", value: Object.keys(data.outlet_attributes).length === 0 && data.outlet_attributes.constructor === Object ?
                    [] : data.outlet_attributes
                },
                "outlet_detail"
              ));
            let draft = await store.put(       // eslint-disable-line
              { key: "draft_123", value: false },
              "is_draft_saved"
            );
          }
          
          if (!data.select_all_flags?.channel_detail) {
            let txss = db.transaction(["product_store"], "readwrite");
            let objectStore = txss.objectStore(storeName);
            let objectStoreRequest = objectStore.delete("selectedAllChannelFlags");       // eslint-disable-line
          } else {
            const outlet =       // eslint-disable-line
              data.select_all_flags.channel_detail &&
              (await store.put(
                {
                  key: "sele_cha_123", value: Object.keys(data.select_all_flags.channel_detail).length === 0 && data.select_all_flags.channel_detail.constructor === Object ?
                    [] : data.select_all_flags.channel_detail
                },
                "selectedAllChannelFlags"
              ));
            let draft = await store.put(       // eslint-disable-line
              { key: "draft_123", value: false },
              "is_draft_saved"
            );
          }
          if (!data.select_all_flags?.geographic_detail) {
            let txss = db.transaction(["product_store"], "readwrite");
            let objectStore = txss.objectStore(storeName);
            let objectStoreRequest = objectStore.delete("selectedAllGeoFlags");       // eslint-disable-line
          } else {
            const outlet =       // eslint-disable-line
              data.select_all_flags.geographic_detail &&
              (await store.put(
                {
                  key: "sele_geo_123", value: Object.keys(data.select_all_flags.geographic_detail).length === 0 && data.select_all_flags.geographic_detail.constructor === Object ?
                    [] : data.select_all_flags.geographic_detail
                },
                "selectedAllGeoFlags"
              ));
            let draft = await store.put(       // eslint-disable-line
              { key: "draft_123", value: false },
              "is_draft_saved"
            );
          }
          if (!data.select_all_flags?.outlet_detail) {
            let txss = db.transaction(["product_store"], "readwrite");
            let objectStore = txss.objectStore(storeName);
            let objectStoreRequest = objectStore.delete("selectedAllOutletFlags");       // eslint-disable-line
          } else {
            const outlet =       // eslint-disable-line
              data.select_all_flags.outlet_detail &&
              (await store.put(
                {
                  key: "sele_Out_123", value: Object.keys(data.select_all_flags.outlet_detail).length === 0 && data.select_all_flags.outlet_detail.constructor === Object ?
                    [] : data.select_all_flags.outlet_detail
                },
                "selectedAllOutletFlags"
              ));
            let draft = await store.put(       // eslint-disable-line
              { key: "draft_123", value: false },
              "is_draft_saved"
            );
          }
          if (!PreOpso) {
            let txss = db.transaction(["product_store"], "readwrite");
            let objectStore = txss.objectStore(storeName);
            let objectStoreRequest = objectStore.delete("preopso_detail");       // eslint-disable-line
          } else {
            const product = await store.put(       // eslint-disable-line
              { key: "pre_123", value: PreOpso },
              "preopso_detail"
            );
            let draft = await store.put(       // eslint-disable-line
              { key: "draft_123", value: false },
              "is_draft_saved"
            );
          }
          await tx.dones;
        return false
          //   this.setState({ isSaveDraft: false });

        };
    
        saveData(data);
      }

      static   del_restriction_fromIdb = () => {
        const saveData = async (data) => {
          if (!("indexedDB" in window)) {
            console.warn("IndexedDB not supported");
            return;
          }
    
    
          const dbName = "gt_form";
          const storeName = "product_store";
          const version = 1; //versions start at 1
    
          const db = await openDB(dbName, version, {
            upgrade(db, oldVersion, newVersion, transaction) {
              db.createObjectStore(storeName);
            },
          });
    
          const tx = await db.transaction(storeName, "readwrite");
          const store = await tx.objectStore(storeName);       // eslint-disable-line
          let txss = db.transaction(["product_store"], "readwrite");
          let objectStore = txss.objectStore(storeName);
          // let objectStoreRequest = objectStore.delete("product_detail");
          let objectStoreRequests = objectStore.delete("is_newPromotion");       // eslint-disable-line
        }
        saveData(undefined)
      }
}